<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectTechIssueType,
} from '../../../../model/additional-info/support/info-technical-issue/select-tech-issue-type.hook'

defineOptions({
  name: 'SelectTechIssueType',
})

const {
  placeholder,
  model,
  options,
} = useSelectTechIssueType()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
